





























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import { Meta, MetaInfo } from '@/decorators';
import { mdiClose } from '@mdi/js';
import { axios } from '@/plugins/axios';

// Static import for faster rendering
import { StickyHeader, Footer } from '@/components/layout';
import { mapActions } from 'vuex';

import _ from 'lodash';
import dayjs from 'dayjs';
declare const BRUM_APPDYNAMICS: string;

import { extendSession } from '@/services/api/psben2/api';
import { InfosPSBEN } from '@/store/infosPSBEN/types';
import { ParametresUtilisateur } from '@/store/parametresUtilisateur/types';
import { Watch } from 'vue-property-decorator';

/** App is the main component */
@Component({
	components: {
		StickyHeader,
		Footer
	},
	methods: {
		...mapActions('globalState', ['addLoading', 'removeLoading', 'updateDataLoaded']),
		...mapActions('infosPSBEN', ['fetchInfosPSBEN'])
	}
})
export default class App extends Vue {
	@Getter('globalState/loading') loading!: boolean;
	@Getter('parametresUtilisateur/getParametresUtilisateur') parametresUtilisateur!: Map<string, ParametresUtilisateur>;
	@Getter('infosPSBEN/getErrorInfosPSBEN') errorPsben!: boolean;
	@Getter('infosPSBEN/getExpirationTs') expirationTs!: number | undefined;
	@Getter('infosPSBEN/getExtensions') extensions!: number | undefined;
	@Getter('infosPSBEN/getDelayDisplaySession') delay!: number | undefined;
	@Getter('infosPSBEN/getExtensionSessionAvailable') extensionSession!: boolean | undefined;
	@Getter('infosPSBEN/getInfosPSBEN') infosPsben!: InfosPSBEN;

	isPdfWindow = false;
	userAgent = _.get(window, 'navigator.userAgent', '');
	displayIEMessage = true;
	isExpirationWarningDisplayed = false;
	close = mdiClose;
	isReady = false;

	axios = axios;

	displayExpirationWarning() {
		this.isExpirationWarningDisplayed = true;
	}

	manageExpirationWarningDisplay() {
		if (this.expirationTs !== undefined && this.delay !== undefined) {
			const minuteDelay = dayjs.unix(this.expirationTs).diff(dayjs(), 'minute') - this.delay;
			_.debounce(this.displayExpirationWarning, minuteDelay * 60 * 1000)();
		}
	}

	redirectWithNewPsben(newPsben: string, path: string = '/vaccination-covid/accueil') {
		const origin = window.location.origin;
		const formattedPsben = encodeURIComponent(newPsben);
		window.location.replace(origin + path + '?psben=' + formattedPsben);
	}

	extendSessionAndRedirect() {
		if (this.isExtensionPossible) {
			this.addLoading();
			const parametresUtilisateur =
				this.parametresUtilisateur.get(_.get(this.infosPsben, 'ps.numRPPS')) as ParametresUtilisateur;
			const psDelegation = _.get(parametresUtilisateur, 'delegation');
			extendSession(psDelegation).then((response) => {
				this.redirectWithNewPsben(_.get(response, 'data.value'));
				this.removeLoading();
			})
			.catch(() => {
				this.removeLoading();
			});
		}
	}

	get isExtensionPossible() {
		return this.extensionSession && this.extensions !== undefined && this.extensions! >= 0 && this.extensions! < 3;
	}

	get messageLienExpiration() {
		return _.includes(_.get(this.$route, 'path'), '/accueil') ?
			'prolonger ma session' :
			'prolonger ma session et retourner à l\'accueil';
	}

	get isErrorPage(): boolean {
		return _.includes(_.get(this.$route, 'path'), '/error');
	}

	// Vérifie si le navigateur est Internet Explorer
	get isIE(): boolean {
		return _.includes(this.userAgent, 'MSIE') || _.includes(this.userAgent, 'Trident/');
	}

	/** The meta informations of the route */
	@Meta
	metaInfo(): MetaInfo {
		return {
			// If no sub-components specify a metaInfo.title, this title will be used
			title: 'Vaccin COVID',
			// All titles will be injected into this template
			titleTemplate: '%s',
			meta: [
				{
					name: 'description',
					content: 'Service de saisie de vaccination covid.'
				}
			]
		};
	}

	createScript(urlAppdyanamicsEnv: string) {
		const scriptDate = document.createElement('script');
		scriptDate.type = 'text/javascript';
		scriptDate.text = 'window[\'adrum-start-time\']=new Date().getTime();';
		scriptDate.onload = _.noop;
		const scriptAppDynamics = document.createElement('script');
		scriptAppDynamics.type = 'text/javascript';
		scriptAppDynamics.setAttribute('src', urlAppdyanamicsEnv );
		scriptAppDynamics.onload = _.noop;
		document.head.appendChild(scriptDate);
		document.head.appendChild(scriptAppDynamics);
	}

	technicalOrErrorPage() {
		return window.location.pathname.includes('/error') ||
			window.location.pathname.includes('/pdf') ||
			_.isEmpty(this.axios.defaults.headers.common.psben2);
	}

	@Watch('$route', { immediate: true, deep: true })
	onUrlChange() {
		if (this.technicalOrErrorPage()) {
			this.isReady = true;
		}
	}

	created(): void {
		if (!this.technicalOrErrorPage()) {
			this.addLoading();
			this.fetchInfosPSBEN().then((newPsben: string) => {
				if (newPsben) {
					this.redirectWithNewPsben(newPsben);
				} else {
					this.isReady = true;
					this.manageExpirationWarningDisplay();
				}
			})
			.finally(this.removeLoading);
		} else {
			this.isReady = true;
		}

		if (BRUM_APPDYNAMICS) {
			this.createScript(BRUM_APPDYNAMICS);
		}
	}
}
